import { FC } from 'react';
import { Form, useToggle } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Input } from 'components/form/Input';
import { maskCvvCredit } from 'helpers/masks';
import { composeValidators, cvvCard, required } from 'helpers/validators';
import { OfUnion } from 'types/common';
import { ScButtonEye } from 'components/form/Password';
import { useTheme } from 'hooks/theme';

const validateCvvCard = composeValidators(required, cvvCard);

export const FieldCvvCard: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.Cvv]
> = ({ fieldName, label }) => {
  const { images } = useTheme();

  const [showCvv, toggleShowCvv] = useToggle(false);

  return (
    <FormGroup title={label || fieldName}>
      <Input
        field={fieldName}
        validate={validateCvvCard}
        formatter={maskCvvCredit}
        type={showCvv ? 'text' : 'password'}
        addons={
          <ScButtonEye type="button" onClick={toggleShowCvv} isOpen={showCvv}>
            <div className="eye opened-eye">
              <images.eyeOpenIcon.component />
            </div>
            <div className="eye closed-eye">
              <images.eyeClosedIcon.component />
            </div>
          </ScButtonEye>
        }
      />
    </FormGroup>
  );
};
